import { PromotionType } from '../types/offers';

type ModelFamilyOption = {
  [key: string]: {
    label: string;
    ariaLabel: string;
    value: string;
    tabs: string[];
  };
};

export type ModelGroups = {
  [key: string]: string[]; // modelGroup: modelFamily[]
};

export type GroupedOffers = {
  [modelGroup: string]: {
    [modelFamily: string]: PromotionType[];
  };
};

export const groupOffersByModelGroup = (
  offers: PromotionType[],
  modelGroups: ModelGroups,
): GroupedOffers => {
  // Create a reverse mapping of modelFamily to modelGroup using reduce
  const modelFamilyToGroupMap = Object.entries(modelGroups).reduce(
    (acc, [group, families]) => {
      families.forEach((family) => {
        acc[family] = group;
      });
      return acc;
    },
    {} as { [modelFamily: string]: string },
  );

  // Initialize the grouped offers structure with only model groups
  const groupedOffers = Object.keys(modelGroups).reduce((acc, group) => {
    acc[group] = {}; // Initialize each group with an empty object
    return acc;
  }, {} as GroupedOffers);

  // Populate the grouped offers with the actual offers
  offers.forEach((offer) => {
    const modelFamily = offer.offerModelDetail.modelFamily.replace(/[ -]/g, '').toLowerCase();
    const modelGroup = modelFamilyToGroupMap[modelFamily];

    if (modelGroup) {
      // Initialize the model family array if it doesn't exist
      if (!groupedOffers[modelGroup][modelFamily]) {
        groupedOffers[modelGroup][modelFamily] = [];
      }

      // Push the offer to the corresponding family within the group
      groupedOffers[modelGroup][modelFamily].push(offer);
    }
  });
  return groupedOffers;
};

export const groupModelFamily = (modelFamilyOptions: ModelFamilyOption) => {
  // Filter options with defined tabs
  const allOptions = Object.values(modelFamilyOptions);

  // Group options by tabs using reduce
  const groupedByTabs = allOptions.reduce(
    (acc, item) => {
      item.tabs?.forEach((tab) => {
        acc[tab] = acc[tab] || [];
        acc[tab].push(item.value);
      });
      return acc;
    },
    {} as { [key: string]: string[] },
  );

  return groupedByTabs;
};
